import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../Assets/logo.png';
import loading from '../Assets/loading.gif';
import { name, ApiEndpoint, platform } from "../Constant";
import Footer from "../Components/footer";
import Button from "../Components/button";
import * as axios from 'axios';
import { doRegister, RedirectIfLogin, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";
import $ from "jquery";
import { SearchSelect } from '../Components/searchselect';

class Register extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      title : '',
      name: '',
      email: '',
      email2: '',
      phone: '',
      company: '',
      company_number: '',
      company_address: '',
      position: '',
      country: '',
      region: '',
      regionID: '',
      division: '',
      message: '',
      loading: '',
      retry_times: 0,
      geo_ip: '',
      type: '',
      allRegion: [],
      allTitle: [],
      allDivision: [],
      allPosition: [],
    }

    this.label = "";
    this.SelectInput = React.createRef();
    //this.SelectInput = this.SelectInput.bind(this);
    }

  
    componentDidMount(){
    if(this.props.match.params?.a && this.props.match.params?.a?.length > 0 && (this.props.match.params?.a == 'contractor' || this.props.match.params?.a == 'user')){
    this.PreloadDatas();
     UpdateState(this, 'type', this.props.match.params?.a);
     }

     this.label = (this.props.match.params?.a && this.props.match.params?.a?.length > 0 && this.props.match.params?.a == 'contractor') ? "Company " : "";
    RedirectIfLogin();
    }

    componentWillReceiveProps(newProps){
      window.setTimeout(
        function(){
      if(newProps.match.params?.a && newProps.match.params?.a?.length > 0 && (newProps.match.params?.a == 'contractor' || newProps.match.params?.a == 'user')){
        this.PreloadDatas();
        UpdateState(this, 'type', newProps.match.params?.a);
         }
        }.bind(this), 1000);

        this.label = (newProps.match.params?.a && newProps.match.params?.a?.length > 0 && newProps.match.params?.a == 'contractor') ? "Company " : "";
    }

    componentDidUpdate(prevProps) {
      RedirectIfLogin();
    }

  
    componentWillUnmount(){
    UpdateState(this, 'message', '');
    UpdateState(this, 'allTitle', '');
    UpdateState(this, 'geo_ip', '');
    UpdateState(this, 'region', '');
    UpdateState(this, 'regionID', '');
    UpdateState(this, 'country', '');
    UpdateState(this, 'allDivision', '');
    UpdateState(this, 'allPosition', '');
    }


    PreloadDatas = async () => {
      let header = {
       headers : {
        'Accept': 'application/json',
        'Content-Type': "application/x-www-form-urlencoded",
         'Authorization': "Bearer " + name + ", Session " + name +", Platform "+ platform,
         'My-Custom-Header': name,
         'User-Agent': name+ " Bot",
      }
    };

    let datas = new URLSearchParams({
      command: 'fetch',
      cmd: 'fetchcontact',
      q: 'fetchAll',
      t: (this.props.match.params?.a && this.props.match.params?.a?.length > 0 && this.props.match.params?.a == 'contractor') ? "contractor" : "user",
    }).toString();
    
      axios.get(ApiEndpoint+"/preloadRegData?"+datas, header)
      .then(response => {

       if(response?.data?.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
            setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.PreloadDatas();
              }, 4000);
             }
             }
           }

 
     if(response?.data?.error == false && response?.data?.error != true){
 
     UpdateState(this, 'allDivision', response?.data?.data?.allDivisions);
     UpdateState(this, 'allTitle', response?.data?.data?.allTitles);
     UpdateState(this, 'allPosition', response?.data?.data?.allPositions);
     UpdateState(this, 'geo_ip', response?.data?.geo?.geo_ip);
     UpdateState(this, 'region', response?.data?.geo?.region);
     UpdateState(this, 'regionID', response?.data?.geo?.region_id);
     UpdateState(this, 'country', response?.data?.geo?.country);
     UpdateState(this, 'message', '');

     if(response?.data?.data?.allDivisions?.length > 0){
      $('.searchableInput').removeClass('readonly');
     }
 
     if(response?.data?.geo?.geo_ip == "" || response?.data?.geo?.region == "" || response?.data?.geo?.country == "" || response?.data?.geo?.region_id == ""){
       this.PreloadDatas();
     }
     }
     else if(response.data.error != false){
       AlertMessage(this, response.data.error, 'error');
     }
     else{
       AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
     }
   }).catch(err => {
       AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
       this.PreloadDatas();
   });
     
   }

   doTerms = () => {
     if($('input#terms').is(':checked')){
     UpdateState(this, 'terms', "1");
     }
     else{
       UpdateState(this, 'terms', "0");
     }
   }
    
render() {
    return (
        <div className="App">
      <div className="body-wrapper" id="body-wrapper">
      <div className="form-first-child"> </div>

        <div className="form-wrapper">
      <div className="form-wrap">
        <div className="logo-wrap">
          <div className="logo-inner-wrap">
          <NavLink to="/">
            <img className="logo" src={logo} title={name + " Logo"} alt={name + " Logo"}/>
            </NavLink>
          </div>
          </div>
      <div className="form-inner-wrap">
       <div className="h1s">Register on {name}. </div>
     
       <BreedForm route="register">

      {(this.props.match.params?.a && this.props.match.params?.a?.length > 0 && (this.props.match.params?.a == 'contractor' || this.props.match.params?.a == 'user')) ?
    (<>
      <div className="info-nos" style={{background: '#F2F2F5', padding: '8px'}}>Register as {(this.props.match.params?.a && this.props.match.params?.a?.length > 0 && this.props.match.params?.a == 'contractor') ?
       (<>a <b style={{color: 'red'}}>PUBLISHING COMPANY</b></>) : (<>a <b style={{color: 'red'}}>SCHOLAR</b></>)}</div><br/>

      {AlertMessageOut(this)}

       <div className="form-col-row">
       <div className="form-col-lg">  
       <select  type="text" className={getState(this, 'allTitle')?.length > 0 ? 'form-input' : 'form-input readonly'} id="title" placeholder="Title"
      onChange={(input) => UpdateState(this, "title", input.target.value) } disabled={getState(this, 'allTitle')?.length > 0 ? '' : 'disabled'}>
        <option value="">Select Title</option>
     {getState(this, 'allTitle')?.map((title, i) => {
      return <option key={i} value={title.value}>{title.text}</option>
     })}
        </select>
       </div>

       <div className="form-col-lg">  
       <input type="text" className="form-input" id="name" placeholder="Full Name"
      onChange={(input) => UpdateState(this, "name", input.target.value) }/>
       </div>
       </div>

       {(this.props.match.params?.a && this.props.match.params?.a?.length > 0 && this.props.match.params?.a == 'contractor') ?
       (<>
       <div className="form-col-row">
       <div className="form-col-lg">  
       <input type="text" className="form-input" id="company" placeholder="Company Name/Institution"
      onChange={(input) => UpdateState(this, "company", input.target.value) }/>
       </div>

       <div className="form-col-lg">  
       <input type="text" className="form-input" id="company_number" placeholder="Company Registration Number"
      onChange={(input) => UpdateState(this, "company_number", input.target.value) }/>
       </div>
       </div>

       <div className="form-col-row">
       <div className="form-col-lg">  
       <input type="text" className="form-input" id="company_address" placeholder="Company Registered Address"
      onChange={(input) => UpdateState(this, "company_address", input.target.value) }/>
       </div>

       <div className="form-col-lg">  
       <select  type="text" className={getState(this, 'allPosition')?.length > 0 ? 'form-input' : 'form-input readonly'} id="position" placeholder="Position"
      onChange={(input) => UpdateState(this, "position", input.target.value) } disabled={getState(this, 'allPosition')?.length > 0 ? '' : 'disabled'}>
     <option value="">Select Position</option>
     {getState(this, 'allPosition')?.map((position, i) => {
      return <option key={i} value={position.value}> {position.text} </option>
     })}
        </select>
       </div>
       </div>

       <div className="form-col-row">
       <div className="form-col-lg">  
       <input type="text" className="form-input" id="email" placeholder="Company Email Address"
      onChange={(input) => UpdateState(this, "email", input.target.value) }/>
       </div>

       <div className="form-col-lg">  
       <input type="text" className="form-input" id="email2" placeholder="Confirm Email Address"
      onChange={(input) => UpdateState(this, "email2", input.target.value) }/>
       </div>
       </div>


       <div className="form-col-row">
       <div className="form-col-lg">  
       <input type="text" className="form-input onlynumber" id="phone" placeholder="Company Phone number"
      onChange={(input) => UpdateState(this, "phone", input.target.value) }/>
        </div>

       <div className="form-col-lg"> 
       <SearchSelect ref={this.SelectInput} data={getState(this, 'allDivision')} placeholder="Select Field of Specialization" focusplaceholder="Search Field of Specialization..." self={this} state="division" />
       </div>
       </div>

       </>) : (<>
       
        <div className="form-col-row">
       <div className="form-col-lg">  
       <input type="text" className="form-input" id="email" placeholder="Official Email Address"
      onChange={(input) => UpdateState(this, "email", input.target.value) }/>
       </div>

       <div className="form-col-lg">  
       <input type="text" className="form-input" id="email2" placeholder="Confirm Email Address"
      onChange={(input) => UpdateState(this, "email2", input.target.value) }/>
       </div>
       </div>


       <div className="form-col-row">
       <div className="form-col-lg">  
       <input type="text" className="form-input onlynumber" id="phone" placeholder="Phone number"
      onChange={(input) => UpdateState(this, "phone", input.target.value) }/>
        </div>

       <div className="form-col-lg"> 
        <SearchSelect ref={this.SelectInput} data={getState(this, 'allDivision')} placeholder="Select Field of Specialization" focusplaceholder="Search Field of Specialization..." self={this} state="division" />
       </div>
       </div>

       <div className="form-col-row">
       <div className="form-col-lg">  
       <input type="text" className="form-input" id="company" placeholder="Institution"
      onChange={(input) => UpdateState(this, "company", input.target.value) }/>
       </div>

       <div className="form-col-lg">  
       <select  type="text" className={getState(this, 'allPosition')?.length > 0 ? 'form-input' : 'form-input readonly'} id="position" placeholder="Position"
      onChange={(input) => UpdateState(this, "position", input.target.value) } disabled={getState(this, 'allPosition')?.length > 0 ? '' : 'disabled'}>
     <option value="">Select Position</option>
     {getState(this, 'allPosition')?.map((position, i) => {
      return <option key={i} value={position.value}> {position.text} </option>
     })}
        </select>
       </div>
       </div>
       </>)}

     
      {/*<Button 
       wrapperClass="form-group-lg" 
       buttonClass="btn btn-blue btn-link" 
       buttonText="CREATE ACCOUNT"
       buttonAction="register"
      self={this} />*/}


      <div className="form-col-rows">
       <div className="form-col-lg" style={{textAlign: 'center'}}>  
      <input onClick={(input) => this.doTerms()} type="checkbox" value="1" id="terms"/> Accept <a href={ApiEndpoint+"/uploads/site/terms.pdf"}>Terms and Condition</a>
       </div>
       </div>

    <div className="form-group-lg">
      <button className="btn btn-blue btn-link reg-btn"
           onClick={() => { doRegister(this) } }>
               Register
                </button>
                
                <button className={"btn btn-blue btn-link disabled reg-loading loading hide"}>
                <img height="40px" src={loading} alt="Loading..."/>
             </button>
        </div>
        </>)  : (<>
          <div className="form-group-lg">    
         <NavLink to="/register/user">
           <button className="btn btn-blue btn-link">SCHOLARS</button>
           </NavLink>
         </div> 
         <div className="form-group-lg">
         <NavLink to="/register/contractor">
       <button className="btn btn-pink btn-link">PUBLISHERS</button>
       </NavLink>
       </div> 
        </>)
    }

       </BreedForm>
         </div>
        </div>
      </div>
      </div>

      <Footer/>
    </div>
    );
}
}

export default Register;